import { useEffect } from 'react';
import { useLayoutContext } from './Layout';

export function PageHeader({ title, rightContent }) {
  const { setTitle, setRightContent } = useLayoutContext();

  useEffect(() => {
    setTitle(title);
    if (rightContent) {
      setRightContent(rightContent);
    } else {
      setRightContent(null);
    }

    return () => {
      setTitle(null);
      setRightContent(null);
    };
  }, [title, rightContent, setTitle, setRightContent]);

  return null;
}

